import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from '@repo-level/core-front';

import { FormGroup } from 'components/form/groups/FormGroup';
import { Input } from 'components/form/Input';
import { maskCardNumber } from 'helpers/masks';
import { cardNumber, composeValidators, required } from 'helpers/validators';
import { OfUnion } from 'types/common';
import { useFieldState } from 'informed';

const validateCardNumber = composeValidators(required, cardNumber);

export const FieldCreditCardNumber: FC<
  OfUnion<Form.MethodField>[Form.MethodFieldType.CreditCardNumber]
> = ({ fieldName }) => {
  const { t } = useTranslation('glossary');
  const [isFocused, setIsFocused] = useState(false);
  const fieldState = useFieldState(fieldName);

  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(false);

  const getPlaceholder = () => {
    if (isFocused || fieldState?.value) {
      return t('cardNumber');
    }
    return t('cardNumberDefault');
  };

  return (
    <FormGroup marginBottom={8}>
      <Input
        field={fieldName}
        id={fieldName}
        validate={validateCardNumber}
        formatter={maskCardNumber}
        animatedPlaceholder={getPlaceholder()}
        onFocus={handleFocus}
        validateOnBlur
        onBlur={handleBlur}
      />
    </FormGroup>
  );
};
